export interface Exchange30DayPrice {
  source: string
  currency: string
  lastInBTC?: number
  low30daysInBTC?: number
  high30daysInBTC?: number
  change30daysInPercent?: number
  volume30daysInTokens?: number
  lastInUSD?: number
  low30daysInUSD?: number
  high30daysInUSD?: number
  change30daysInPercentUSD?: number
  volume30daysInTokensUSD?: number
  hasUSDData?: boolean
  [key: string]: string | number | boolean | undefined
}

export interface ExchangeOrder {
  source?: string
  symbol?: string
  currency?: string
  bidAmount?: number | null
  askAmount?: number | null
  bidPrice?: number | null
  askPrice?: number | null
  spreadPercentage?: number | null
  [key: string]: string | number | boolean | null | undefined
}

/** Raw market payload from trading queries (loading flag is composed in context). */
export interface TradingMarketData {
  prices: Exchange30DayPrice[] | null
  orderBook: ExchangeOrder[] | null
}

export const normalizeExchange30DayPrices = (
  prices: readonly Exchange30DayPrice[] | null | undefined,
): Exchange30DayPrice[] => {
  if (!Array.isArray(prices) || prices.length === 0) return prices ? [...prices] : []

  const groupedPrices: Record<string, Exchange30DayPrice[]> = {}

  prices.forEach((priceSource) => {
    if (!groupedPrices[priceSource.source]) {
      groupedPrices[priceSource.source] = []
    }
    groupedPrices[priceSource.source].push(priceSource)
  })

  if (groupedPrices.bitfinex?.length > 1) {
    const bitfinexBTC = groupedPrices.bitfinex.find((p) => p.currency === 'btc')
    const bitfinexUSD = groupedPrices.bitfinex.find((p) => p.currency === 'usd')

    if (bitfinexBTC && bitfinexUSD) {
      const combinedBitfinex: Exchange30DayPrice = {
        ...bitfinexBTC,
        lastInUSD: bitfinexUSD.lastInBTC,
        low30daysInUSD: bitfinexUSD.low30daysInBTC,
        high30daysInUSD: bitfinexUSD.high30daysInBTC,
        change30daysInPercentUSD: bitfinexUSD.change30daysInPercent,
        volume30daysInTokensUSD: bitfinexUSD.volume30daysInTokens,
        hasUSDData: true,
      }
      return [...(groupedPrices.sideswap ?? []), combinedBitfinex]
    }
  }

  return [...prices]
}
